/**
 * Contributor arche detail page: the Asset Library section, the content-pack
 * bill (ADR-021 §11), the shared
 * Workspace libraries section (ADR-019), the Help
 * Documentation section (AI-generated help articles + the "refresh
 * documentation" command surface — see docs/arche-knowledge.md), and the
 * window-total failed-invocation rollup.
 */

import { useParams, Link } from 'react-router-dom';
import { AssetLibraryManager } from '../components/AssetLibraryManager';
import { ContentPackBillingSection } from '../components/ContentPackBillingSection';
import { WorkspaceLinksSection } from '../components/WorkspaceLinksSection';
import { DocumentationSection } from '../components/DocumentationSection';
import { InvocationFailuresSection } from '../components/InvocationFailuresSection';

export default function ArcheDetailPage() {
  const { archeId } = useParams<{ archeId: string }>();

  if (!archeId) {
    return (
      <div className="container mx-auto p-6">
        <div className="text-destructive">Missing arche id in URL.</div>
        <Link to="/contributor/dashboard" className="text-sm text-primary hover:underline">
          ← Back to dashboard
        </Link>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6">
      <div className="mb-4 text-sm text-muted-foreground">
        <Link to="/contributor/dashboard" className="hover:underline">
          ← My arches
        </Link>
      </div>
      <h1 className="text-2xl font-bold">Arche</h1>
      <div className="mb-6 font-mono text-xs text-muted-foreground">{archeId}</div>
      <AssetLibraryManager archeId={archeId} />
      <ContentPackBillingSection archeId={archeId} />
      <WorkspaceLinksSection archeId={archeId} />
      <DocumentationSection archeId={archeId} />
      <InvocationFailuresSection archeId={archeId} />
    </div>
  );
}
